import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { setSEO } from "./utils/seo";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import HeroSlider from "./components/HeroSlider";
import CarTypeSelection from "./components/CarTypeSelection";
import Testimonials from "./components/Testimonials";
import HowItWorks from "./components/HowItWorks";
import Footer from "./components/Footer";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import HowCreditAffectsApprovals from "./pages/blogPosts/HowCreditAffectsApprovals";
import TopFinancingOptions2025 from "./pages/blogPosts/TopFinancingOptions2025";
import TipsImproveApproval from "./pages/blogPosts/TipsImproveApproval";
import MultiStepForm from "./components/MultiStepForm";
import LoanCalculator from "./pages/LoanCalculator";
import TermsAndConditions from "./pages/TermsAndConditions";
import Eligibility from "./pages/Eligibility";
import ApplyPage from "./pages/ApplyPage";
import GetApproved from "./pages/GetApproved";
import ScrollToTop from "./ScrollToTop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BadCreditCarLoans from "./pages/BadCreditCarLoans";





// ⭐ Fix: Create a wrapper so we can use useLocation() inside Route element
function HomeWrapper() {
  const location = useLocation();
  const openApply = location.state?.openApply || false;

  useEffect(() => {
    setSEO({
      title: "YesAuto – Fast Car Financing Approval in Canada",
      description:
        "Get approved for car financing fast with YesAuto. Bad credit, new credit, or no credit — we help Canadians drive today.",
    });
  }, []);

  return (
    <>
      <HeroSlider />
      <CarTypeSelection openApply={openApply} />
      <div className="mb-32"></div>
      <HowItWorks />
      <div className="mb-32"></div>
      <Services />
      <div className="mb-32"></div>
      <Testimonials />
      <div className="mb-32"></div>
    </>
  );
}


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        {/* HOME FIXED */}
        <Route path="/" element={<HomeWrapper />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/how-credit-affects-approvals" element={<HowCreditAffectsApprovals />} />
        <Route path="/blog/top-financing-options-2025" element={<TopFinancingOptions2025 />} />
        <Route path="/blog/5-tips-improve-approval" element={<TipsImproveApproval />} />
       

        <Route path="/loan-calculator" element={<LoanCalculator />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/eligibility" element={<Eligibility />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        
<Route path="/get-approved" element={<GetApproved />} />
<Route path="/bad-credit-car-loans" element={<BadCreditCarLoans />} />

      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
